export default __webpack_public_path__ + "static/media/TestManagement_1.dcd7bdd4.svg";